import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NSAutocompleteModule, NSGridModule, NSSelectModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import {
  CarMovementInquiryActions,
  FleetDetailsActions,
  LoadTrainPermitComponent,
  LocationCalendarActions,
  PermitDetailsActionComponent,
  RemarksColumnComponent,
  TrainConsistActionComponent,
  TrainRouteActions,
  WaybillDetailsListActions,
  WaybillInquiryActions
} from '@ruby/modules/unit-train/submodules/ut-advance-search/components/grid-cells.index';
import { UTResultsGridComponent } from '@ruby/modules/unit-train/submodules/ut-advance-search/components/ut-results-grid/ut-results-grid.component';
import { UTResultsGridContainer } from '@ruby/modules/unit-train/submodules/ut-advance-search/containers/ut-results-grid/ut-results-grid.container';
import { UTAdvanceSearchRoutingModule } from '@ruby/modules/unit-train/submodules/ut-advance-search/ut-advance-search-routing.module';
import { UTFiltersFormModule } from '@ruby/modules/unit-train/submodules/ut-filters-form/ut-filters-form.module';
import { CRFavoritesReportModule } from '@ruby/shared/cr-favorites/cr-favorites-report.module';
import { CarMovementInquiryDialogModule } from '@ruby/shared/dialogs/unit-train/car-movement-inquiry/car-movement-inquiry.module';
import { FleetDetailsDialogModule } from '@ruby/shared/dialogs/unit-train/fleet-details/fleet-details.module';
import { LoadTrainConfirmationDialogModule } from '@ruby/shared/dialogs/unit-train/load-train-confirmation/load-train-confirmation.module';
import { LocationCalendarModule } from '@ruby/shared/dialogs/unit-train/location-calendar/location-calendar.module';
import { PermitDetailModule } from '@ruby/shared/dialogs/unit-train/permit-detail/permit-detail.module';
import { TraceCarDialogModule } from '@ruby/shared/dialogs/unit-train/trace-car/trace-car.module';
import { ViewPermitDialogModule } from '@ruby/shared/dialogs/unit-train/view-permit/view-permit.dialog.module';
import { WaybillDetailsTableDialogModule } from '@ruby/shared/dialogs/unit-train/waybill-details-table/waybill-details-table.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    UTResultsGridContainer,
    UTResultsGridComponent,
    TrainRouteActions,
    PermitDetailsActionComponent,
    CarMovementInquiryActions,
    WaybillDetailsListActions,
    WaybillInquiryActions,
    FleetDetailsActions,
    RemarksColumnComponent,
    TrainConsistActionComponent,
    LocationCalendarActions,
    LoadTrainPermitComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    MatFormFieldModule,
    MatSelectModule,
    NSAutocompleteModule,
    MatInputModule,
    MatToolbarModule,
    MatToolbarModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatProgressBarModule,
    MatRadioModule,
    MatCheckboxModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    ReactiveFormsModule,
    UTAdvanceSearchRoutingModule,
    NSSelectModule,
    PermitDetailModule,
    NSSkeletonModule,
    CarMovementInquiryDialogModule,
    WaybillDetailsTableDialogModule,
    CRFavoritesReportModule,
    LoadTrainConfirmationDialogModule,
    FleetDetailsDialogModule,
    TraceCarDialogModule,
    UTFiltersFormModule,
    OwlDateTimeModule,
    MatTooltipModule,
    LocationCalendarModule,
    ViewPermitDialogModule,
    PipesModule
  ]
})
export class UTAdvanceSearchModule {}
